import ResidentRegister from "./ResidentRegister";

export default ResidentRegister;
